import { DateTime } from "luxon"
import { browserName, browserVersion, osName } from "react-device-detect"

import { useRegistrationData } from "hooks/api/details/use-registration-data"

const useDefaultMetrics = () => {
  const { registrationId, guideId } = useRegistrationData()

  return {
    $browser: browserName,
    $browser_version: browserVersion,
    $os: osName,
    $current_url: window.location.href,
    $screen_height: window.screen.height,
    $screen_width: window.screen.width,
    mp_lib: "web",
    time: DateTime.now().setZone("utc").toISO(),
    api_client: "EventMarketingWebsite",
    emw_id: registrationId || null,
    guide_id: guideId || null,
  }
}

export { useDefaultMetrics }
